import {useTheme} from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Moment from "moment";
import {InputAdornment, Paper} from "@mui/material";
import React from "react";
import ValidatedTextField from "../Inputs/ValidatedTextField";
import {alphaNumericCodeValidator, alphaNumericValidator} from "../../Helpers/ValidationHelpers";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const ClientDetailsView = ({
                               client,
                               edit,
                               setActiveForm,
                               isSubmitting,
                               formValid
                           }) => {
    const theme = useTheme();
    
    return (
        <Paper className="paper-rounded-edges">
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" className="detail-header-banner">Client</Typography>
                </Grid>
                <Grid size={{ xs: 12}}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Reg. Number</Typography>
                        {!edit &&
                            <Typography>{client.registrationNumber ?? 'Not provided'}</Typography>
                        }
                        {edit &&
                            <ValidatedTextField
                                id={'registrationNumber'}
                                label={null}
                                validator={alphaNumericValidator}
                                onChange={isValid => (formValid.current.registrationNumber = isValid)}
                                setActiveForm={setActiveForm}
                                isSubmitting={isSubmitting}
                                initialValue={client.registrationNumber}
                                fieldPath={['registrationNumber']}
                                infoAdornment={<InputAdornment position="end">
                                    <Tooltip enterTouchDelay={200} disableFocusListener title={"The client's registration number. In Australia, this is the ABN."}>
                                        <InfoIcon />
                                    </Tooltip>
                                </InputAdornment>}
                                size={"small"}
                                removeHelperTextPadding={true}
                                width={{xs: 200, md: 250}}
                            />
                        }
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Code</Typography>
                        {!edit &&
                            <Typography>{client.clientCode ?? 'Not provided'}</Typography>
                        }
                        {edit &&
                            <ValidatedTextField
                                id={'clientCode'}
                                label={null}
                                validator={alphaNumericCodeValidator}
                                onChange={isValid => (formValid.current.clientCode = isValid)}
                                setActiveForm={setActiveForm}
                                isSubmitting={isSubmitting}
                                initialValue={client.clientCode}
                                fieldPath={['clientCode']}
                                infoAdornment={<InputAdornment position="end">
                                    <Tooltip disableFocusListener title={"An abbreviation for the client, up to 6 characters."}>
                                        <InfoIcon />
                                    </Tooltip>
                                </InputAdornment>}
                                size={"small"}
                                removeHelperTextPadding={true}
                                width={{xs: 200, md: 250}}
                            />
                        }
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Created At</Typography>
                        <Typography>{Moment(client.createdAt).format('D MMM YYYY, h:mma')}</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default ClientDetailsView;